import { render, staticRenderFns } from "./AnalysesStatusManagementIndex.vue?vue&type=template&id=54156789&"
import script from "./AnalysesStatusManagementIndex.vue?vue&type=script&lang=js&"
export * from "./AnalysesStatusManagementIndex.vue?vue&type=script&lang=js&"
import style0 from "./AnalysesStatusManagementIndex.vue?vue&type=style&index=0&id=54156789&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports